import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { Box } from "@material-ui/core";
import { Auth } from "./TopHead";
import { LogoPng } from "icon/LogoPng";
import { MobileBurgerButton } from "./MobileBurgerButton";
import { DaNotificationButton } from "../../components/buttons/DaNotificationButton";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { DRIVER } from "constants/constants";
import { useAppBarStyles } from "./styles";

export const AppBarComponent = () => {
  const classes = useAppBarStyles();
  const { userData } = useTypeSelectors((state) => state.auth);

  return (
    <AppBar className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <Box className={classes.contentContainer}>
          <Box className={classes.logoContainer}>
            <MobileBurgerButton />
            <LogoPng width={120} height={42} />
          </Box>
          <Box className={classes.contentEndContainer}>
            {userData.role === DRIVER && <DaNotificationButton />}
            <Auth />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
